'use client';

import { Header } from './Header';
import { Footer } from './Footer';
import { ThemeProvider } from '@/contexts/ThemeContext';
import { PremiumProvider } from '@/contexts/PremiumContext';
import { FavoritesProvider } from '@/contexts/FavoritesContext';
import { Toaster } from 'react-hot-toast';
import { SessionProvider } from 'next-auth/react';
import { AuthNotifier } from './AuthNotifier';

export function LayoutContent({ children }: { children: React.ReactNode }) {
  return (
    <SessionProvider>
      <PremiumProvider>
        <FavoritesProvider>
          <ThemeProvider>
            <AuthNotifier />
            <Header />
            <main className="flex-1">{children}</main>
            <Footer />
            <Toaster
              position="bottom-right"
              toastOptions={{
                style: {
                  background: '#112240',
                  color: '#fff',
                  border: '1px solid #233554',
                },
              }}
            />
          </ThemeProvider>
        </FavoritesProvider>
      </PremiumProvider>
    </SessionProvider>
  );
}
